import _ from 'lodash';
import Logger from '../util/Logger';
import DateTime from './DateTime'

/**
 * Methods for consistent access to Popin Summary Object properties via server returned JSON.
 *
 *
 *
 * All interactions or accesses on Popin Summary Object fields should be handled via helper method in this
 * class. Methods should only be to avoid `this` scoping issues in nested calls.
 *
 * Utility methods should throw in the case of unexpected constant mismatch such as missing data,
 * all calls to these methods should be guarded at the callsite.
 *
 * Popin Summary objects are returned from GET /admin/tenants/{id}/popins
 *
 *
 {
 status: { … },
 data: {
   "overview": {
   "upcoming_popins": 1,
   "active_popins": 3,
   "completed_popins": 10
   },
   "popins": [
    "active": ...
    "upcoming": ...
    "completed": ...
   ]
 }
 }

 *
 *
 */
export default {

  getId (popin) {
    if (!popin) {
      Logger.assert('Cannot call getId() without a popin object');
    } else {
      const id = _.get(popin, 'id');
      if (!id) {
        Logger.assert('Popin was missing an id');
      } else {
        return id;
      }
    }
  },
  getStartTime (popin) {
    if (!popin) {
      Logger.assert('Cannot call getStartTime() without a popin object');
    } else {
      const unixSeconds = _.get(popin, 'start_time');
      const time = DateTime.unixSecondsToMoment(unixSeconds);
      if (time === null || time === undefined) {
        Logger.error('Missing start_time for ', this.getId(popin));
        return null;
      } else {
        return time;
      }
    }
  },

  getHero (popin) {
    if (!popin) {
      Logger.assert('Cannot call getHero() without a popin object');
    } else {
      const hero = _.get(popin, 'hero');
      if (!hero) {
        Logger.assert('Popin was missing a hero');
      } else {
        return hero;
      }
    }
  },

  getDisplayName (popin) {
    if (!popin) {
      Logger.assert('Cannot call getHero() without a popin object');
    } else {
      const displayName = _.get(popin, 'hero.display_name');
      if (!displayName) {
        Logger.assert('Popin was missing a hero display_name');
      } else {
        return displayName;
      }
    }
  },

  getHeroEmail (popin) {

    if (!popin) {
      Logger.assert('Cannot call getHero() without a popin object');
    } else {
      const heroEmail = _.get(popin, 'hero.email');
      if (!heroEmail) {
        Logger.error('Popin was missing a hero email', this.getId(popin));
        return 'Not Available';
      } else {
        return heroEmail;
      }
    }
  },

  getDelegateCreator (popin) {
    if (!popin) {
      Logger.assert('Cannot call getDelegateCreator() without a popin object');
    } else {
      return _.get(popin, 'delegate_creator') || null;
    }
  },

  getUseCase (popin) {
    if (!popin) {
      Logger.assert('Cannot call getUseCase() without a popin object');
    } else {
      return _.get(popin, 'display_use_case', 'Not available');
    }
  },

  getUsers (popin) {
    if (!popin) {
      Logger.assert('Cannot call getUsers() without a popin object');
    } else {
      return _.get(popin, 'summary.total_viewers', 'Not available');
    }
  },

  getActivities (popin) {
    if (!popin) {
      Logger.assert('Cannot call getActivity() without a popin object');
    } else {
      return _.get(popin, 'summary.total_activity', 'Not available');
    }
  }
};
